import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import { api_url, titleDescription } from "../../config/Config";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import _fetch from "../../config/api";
import toasted from "../../config/toast";
import { getData } from "country-list";
import Select, { SingleValue } from "react-select";
import Loader from "../../config/Loader";
import { countries } from "countries-list";
import {logo} from '../../config/Config';

const Register = (props: any) => {
  const [btnDisable, setbtnDisable] = useState(false);

  const { sponser } = useParams();
  const Navigate = useNavigate();

  console.log('sponsersponsersponser', sponser);


  useEffect(() => {
    document.title = `${props.pageTitle} | ${titleDescription}`;
  });

  const [refferalID, setRefferalID] = useState("");
  // const [fullName, setFullName] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [Pnumber, setNumber] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPasswords, setShowPasswords] = useState(false);
  const [selectCheckbox, setSelectCheckbox] = useState(false);
  // const [selectedCountry, setSelectedCountry] = useState<CountryOption | null>(null);
  // const [phoneNumber, setPhoneNumber] = useState("");
  const [selectedCountry, setSelectedCountry] = useState<CountryOption | null>(
    null
  );
  const [phoneNumber, setPhoneNumber] = useState("");
  const [phoneCode, setPhoneCode] = useState("");
  const [sponsorData, setSponsorData] = useState('');
  const [findedUserName, SetfindedUserName] = useState();

  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };

  const handleTogglePasswords = () => {
    setShowPasswords(!showPasswords);
  };

  useEffect(() => {
    if (sponser != null) {
      getSponsorInfo();
      setRefferalID(sponser);
    }
  }, []);

  const getSponsorInfo = async () => {

    let data = await _fetch(`${api_url}auth/getsponsorInfo?sponsor_id=${sponser}`, "GET", {});

    if (data?.status === "success") {
      setSponsorData(data?.data);
    }
  }

  // type CountryOption = {
  //   value: string;
  //   label: string;
  //   flagUrl: string;
  // };

  type CountryOption = {
    value: string;
    label: string;
    flagUrl: string;
    numericCode: number;
  };

  const CustomOption: React.FC<{
    innerProps: any;
    label: string;
    data: CountryOption;
  }> = ({ innerProps, label, data }) => (
    <div {...innerProps}>
      <img src={data.flagUrl} alt={label} style={{ marginRight: "8px" }} />
      {label}
    </div>
  );

  // const countryOptions: CountryOption[] = getData().map((country) => {
  //   console.log('country', country);
  //   return {
  //     value: country.code,
  //     label: country.name,
  //     flagUrl: `https://flagcdn.com/16x12/${country.code.toLowerCase()}.png`
  //   }
  // });

  const countryOptions: CountryOption[] = Object.entries(countries).map(
    ([code, country]) => ({
      value: code,
      label: country.name,
      flagUrl: `https://flagcdn.com/16x12/${code.toLowerCase()}.png`,
      numericCode: country.phone[0],
    })
  );
  const handleCountryChange = (option: CountryOption | null) => {
    if (option) {
      setSelectedCountry(option);
      setPhoneCode(`+${option.numericCode} `);
      setPhoneNumber("");
    }
  };
  // const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   const inputValue = e.target.value;
  //   if (inputValue.startsWith(phoneCode)) {
  //     setPhoneNumber(inputValue.replace(phoneCode, ""));
  //   } else if (inputValue.length > phoneCode.length) {
  //     setPhoneNumber(inputValue);
  //   }
  // };

  const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;

    // Extract the phone number (excluding the country code)
    let numericValue = inputValue.startsWith(phoneCode)
      ? inputValue.replace(phoneCode, "")
      : inputValue;

    // Ensure the phone number does not exceed 10 digits
    if (numericValue.length > 13) {
      return;
    }

    setPhoneNumber(numericValue);
  };


  const submitRegister = async (e: any) => {
    setbtnDisable(true);
    e.preventDefault();

    let data = {
      sponsor_id: refferalID,
      firstName: firstName,
      lastName: lastName,
      email: email,
      country: selectedCountry?.label,
      country_flag: selectedCountry?.flagUrl,
      phone: phoneNumber,
      phoneCode: phoneCode,
      // "password": password,
      // "confirm_password": confirmPassword
    }

    let res = await _fetch(`${api_url}auth/signup`, "POST", data, {});
    if (selectCheckbox) {
      if (res?.status == "success") {
        localStorage.setItem("auth", 'true');
        localStorage.setItem("accessToken", res?.token);
        localStorage.setItem("user", JSON.stringify(res?.data?.user));
        toasted.success(res?.message);
        Navigate("/waiting-conformation");

        setbtnDisable(false)
      }
      else {
        toasted.error(res?.message);
        setbtnDisable(false)
      }
    } else {
      toasted.error("Please select checkbox");
    }

    // let res = await _fetch(`${api_url}auth/signup`, "POST", data, {});

    // if (selectCheckbox) {
    //   if (res?.status === "success") {
    //     let data2 = {
    //       "name": firstName + ' ' + lastName,
    //       "email": email,
    //       "country": selectedCountry?.label,
    //       'phone':Pnumber,
    //     };

    //     let res2 = await _fetch(`${api_url}tradeX/create-Account`, "POST", data2, {});

    //     if (res2?.status === "success") {
    //       Navigate("/dashboard");
    //     } else {
    //       toasted.error(res2?.message || "Something went wrong with the second request.");
    //     }

    //     setbtnDisable(false);
    //   } else {
    //     toasted.error(res?.message);
    //     setbtnDisable(false);
    //   }
    // } else {
    //   toasted.error("Please select checkbox");
    // }
  };

  const checkUser = async (user_id: any) => {
    let res = await _fetch(`${api_url}auth/checkUser?user=${user_id}`, "GET", {});
    if (res?.status === "success") {
      SetfindedUserName(res?.data?.name);
    }
  }

  return (
    <div className="login-body register-pg">
      {/* <div className="waves"> */}
      <div className="empty">
        <div className="coustom_container">
          <Row className="form-row">
            {/* <Col xl={6} lg={5} md={5} className="left-sec">
              <div className="login-pics">
                <img src={loginimg55} alt="loginimg" />
              </div>
            </Col> */}
            <Col xl={12} lg={12} md={12} className="login-col">
              <div className="waves">
                <div className="form-outer exchange">
                  
                  <div className="form-inner">
                  <div className="form-logo">
                      <img src={logo} alt="" />
                    </div>
                  
                    <div className="form-head">
                      <h2>Register</h2>
                      <p>Create an account</p>
                    </div>
                    <form className="form-start">
                      {sponsorData ? (
                        <>
                          <input type="text" id="email" placeholder="Refferal ID" value={sponsorData} onBlur={() => checkUser(sponsorData)} />
                          <span>{findedUserName}</span>
                        </>
                      ) : (
                        <>
                          <input type="text" id="email" placeholder="Refferal ID" onChange={(e) => { setRefferalID(e.target.value); checkUser(e.target.value) }} value={refferalID} />
                          <span>{findedUserName}</span>
                        </>
                      )
                      }
                      <input type="text" id="email" placeholder="First Name" onChange={(e) => setFirstName(e.target.value)} value={firstName} />
                      <input type="text" id="email" placeholder="Last Name" onChange={(e) => setLastName(e.target.value)} value={lastName} />
                      <input
                        type="text"
                        id="email"
                        className="mb-2"
                        placeholder="Email Address"
                        onChange={(e) => setEmail(e.target.value)}
                        value={email}
                      />
                      {/* <Select
                        options={countryOptions}
                        id="email1"
                        value={selectedCountry}
                        // onChange={(option: SingleValue<CountryOption>) => setSelectedCountry(option)}
                        onChange={handleCountryChange}
                        components={{ Option: CustomOption }}
                        isSearchable
                        placeholder="Select a country..."
                      />
                      <input
                        type="number"
                        id="email"
                        placeholder="Phone Number"
                        onChange={(e) => setNumber(e.target.value)}
                        value={Pnumber}
                      /> */}

                      <Select
                        options={[...countryOptions].sort((a, b) =>
                          a.label === "India" ? -1 : b.label === "India" ? 1 : 0
                        )}
                        id="email1"
                        value={selectedCountry}
                        onChange={handleCountryChange}
                        isSearchable
                        placeholder="Select Country..."
                        styles={{
                          singleValue: (base) => ({
                            ...base,
                            color: "#fff", // Text color of selected value
                          }),
                          input: (base) => ({
                            ...base,
                            color: "#fff", // Text color inside the input
                          }),
                        }}
                        filterOption={(option, inputValue) => {
                          // Show India on top when input starts with 'i'
                          if (
                            option.label
                              .toLowerCase()
                              .startsWith(inputValue.toLowerCase())
                          ) {
                            return true;
                          }
                          return false;
                        }}
                      />

                      {/* <input
                        type="text"
                        placeholder="Phone Number"
                        // value={phoneNumber}
                        value={`${phoneCode}${phoneNumber}`}
                        onChange={handlePhoneChange}
                      /> */}
                      <input
                        type="text"
                        placeholder="Mobile Number"
                        value={`${phoneCode}${phoneNumber}`}
                        onChange={handlePhoneChange}
                        onKeyDown={(e) => {
                          if (
                            !/[0-9]/.test(e.key) &&
                            e.key !== "Backspace" &&
                            e.key !== "Delete"
                          ) {
                            e.preventDefault(); // Prevent non-numeric input
                          }
                        }}
                      />

                      {/* <div className="hide-pass">
                        <input
                          type={showPassword ? "text" : "password"}
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          id="email"
                          placeholder="Password"
                        />

                        <button type="button" onClick={handleTogglePassword}>
                          {showPassword ? (
                            <VisibilityIcon />
                          ) : (
                            <VisibilityOffIcon />
                          )}
                        </button>
                      </div> */}
                      {/* <div className="hide-pass">
                        <input
                          type={showPasswords ? "text" : "password"}
                          value={confirmPassword}
                          onChange={(e) => setConfirmPassword(e.target.value)}
                          id="email"
                          placeholder="Confirm Password"
                        />

                        <button type="button" onClick={handleTogglePasswords}>
                          {showPasswords ? (
                            <VisibilityIcon />
                          ) : (
                            <VisibilityOffIcon />
                          )}
                        </button>
                      </div> */}
                      <div className="login-remfor">
                        <div className="login-check">
                          <input
                            type="checkbox"
                            id="rem-form"
                            onChange={(e: any) =>
                              setSelectCheckbox(e.target.checked)
                            }
                          />
                          <label className="me-label" htmlFor="rem-form">
                            {" "}
                            I agree to the terms of service{" "}
                          </label>
                        </div>
                      </div>
                      <button
                        type="button"
                        className="log-btn"
                        onClick={submitRegister}
                        disabled={btnDisable}
                      >
                        {btnDisable === true && (
                          <Loader LoaderTxt={"Please Wait..."} />
                        )}
                        {btnDisable === false && "Register "}
                      </button>
                      <div className="form-para">
                        <p>
                          Already have an account?{" "}
                          <Link to="/login">Login here</Link>
                        </p>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
    // </div>
  );
};

export default Register;
